import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import CashDepositForm from "./CashDepositForm";

const getInitialValues = () => {
  return {
    cashierDeposits: {},
    organizationId: "",
    depositBankId: "",
    centerId: "",
    depositBankBranchId: "",
    depositBankAccountNumber: "",
    totalDepositAmount: 0,
    totalBalanceCampusCash: 0,
    cashierList: [],
    depositedBy: "",
    denominationDetails: {
      count_2000: "",
      count_1000: "",
      count_500: "",
      count_200: "",
      count_100: "",
      count_50: "",
      count_20: "",
      count_10: "",
      count_5: "",
      count_2: "",
      count_1: "",
    },
  };
};

const formValidationSchema = Yup.object().shape({
  organizationId: Yup.lazy((val) =>
    typeof val === "number"
      ? Yup.number().required("Organization is required")
      : Yup.string().required("Organization is required")
  ),
  centerId: Yup.lazy((val) =>
    typeof val === "number"
      ? Yup.number().required("Center is required")
      : Yup.string().required("Center is required")
  ),
  depositBankId: Yup.number()
    .typeError("Bank is required")
    .required("Bank is required"),
  depositBankBranchId: Yup.number()
    .typeError("Branch is required")
    .required("Branch is required"),
  depositBankAccountNumber: Yup.number()
    .typeError("Account is required")
    .required("Account is required"),
  depositedBy: Yup.string()
    .typeError("Depositor name must be a string")
    .trim()
    .min(3, "Depositor name must be at least 3 characters")
    .max(25, "Depositor name must not exceed 25 characters")
    .matches(
      /^[a-zA-Z. ]+$/,
      "Only alphabets, dots (.), and spaces are allowed"
    )
    .required("Depositor name is required"),
  totalDepositAmount: Yup.number()
    .typeError("Total deposit must be a number")
    .moreThan(0, "Total deposit must be greater than 0")
    .required("Total deposit is required"),
  cashierDeposits: Yup.object()
    .test(
      "at-least-one-deposit",
      "At least one cashier deposit is required",
      (obj) => obj && Object.keys(obj).length > 0
    )
    .required("At least one cashier deposit is required"),
});

const CashDeposit = () => {
  return (
    <Formik
      initialValues={getInitialValues()}
      validationSchema={formValidationSchema}
    >
      {(formikProps) => {
        const { values, setFieldValue, errors, isValid, dirty } = formikProps;

        return (
          <>
            <CashDepositForm
              values={values}
              setFieldValue={setFieldValue}
              errors={errors}
              isValid={isValid && dirty}
            />
          </>
        );
      }}
    </Formik>
  );
};

export default CashDeposit;
